import { ITheme } from "contexts/ThemeContext";
import { StyleSheet, ViewStyle } from "react-native";

export default (props: ITheme) => StyleSheet.create({
    slider: {
        width: 48,
        height: 6,
        borderRadius: 3,
        backgroundColor: props.colors.alto,
        marginTop: 12,
        marginBottom: 12
    },
})